import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Repeat02 = function Repeat02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m11 2 3 3m0 0-3 3m3-3H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 7.2798 2 8.1198 2 9.8v5.7c0 .4644 0 .6966.0257.8916.1772 1.3462 1.2365 2.4055 2.5827 2.5827C4.8034 19 5.0356 19 5.5 19m4.5 0h7.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 16.7202 22 15.8802 22 14.2V8.5c0-.4644 0-.6966-.0257-.8916-.1772-1.3462-1.2365-2.4055-2.5827-2.5827C19.1966 5 18.9644 5 18.5 5M10 19l3 3m-3-3 3-3"
    })
  }));
};
export default Repeat02;